export const CHECKOUT_FLOW = 'CHECKOUT_FLOW'
export const IS_CHECKOUT_BANNER = 'IS_CHECKOUT_BANNER'
export const IS_SUBMISSION_PAGE = 'IS_SUBMISSION_PAGE'
export const SCHOOL_PAGE = 'SCHOOL_PAGE'
